// extracted by mini-css-extract-plugin
export default {"workspaceDueDate":"qjsqL6w-klu+lulnZKweP6cTXhRyqYiBByXjCsXiFdE="};